/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [下载批量申请盘亏模板↗](http://yapi.yishou.com/project/128/interface/api/35581) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportInventoryLossesDemo`
 */
const exportInventoryLossesDemoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/exportInventoryLossesDemo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportInventoryLossesDemo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [下载批量申请盘亏模板↗](http://yapi.yishou.com/project/128/interface/api/35581) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportInventoryLossesDemo`
 */
export const exportInventoryLossesDemo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportInventoryLossesDemoRequestConfig, requestData), ...args);
};
exportInventoryLossesDemo.requestConfig = exportInventoryLossesDemoRequestConfig;
/**
 * 接口 [批量申请盘亏↗](http://yapi.yishou.com/project/128/interface/api/35590) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/batchInventoryLosses`
 */
const batchInventoryLossesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/batchInventoryLosses",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入文件", tsType: "FileData" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "失败的时候，可能会带这个参数，不一定，需要判断参数是否存在" } },
    },
    requestFunctionName: "batchInventoryLosses",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量申请盘亏↗](http://yapi.yishou.com/project/128/interface/api/35590) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/batchInventoryLosses`
 */
export const batchInventoryLosses = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchInventoryLossesRequestConfig, requestData), ...args);
};
batchInventoryLosses.requestConfig = batchInventoryLossesRequestConfig;
/**
 * 接口 [下载批量恢复正常模板↗](http://yapi.yishou.com/project/128/interface/api/35599) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportGetRightBatchDemo`
 */
const exportGetRightBatchDemoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/exportGetRightBatchDemo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportGetRightBatchDemo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [下载批量恢复正常模板↗](http://yapi.yishou.com/project/128/interface/api/35599) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportGetRightBatchDemo`
 */
export const exportGetRightBatchDemo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportGetRightBatchDemoRequestConfig, requestData), ...args);
};
exportGetRightBatchDemo.requestConfig = exportGetRightBatchDemoRequestConfig;
/**
 * 接口 [批量恢复正常↗](http://yapi.yishou.com/project/128/interface/api/35608) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/getRightBatchEdit`
 */
const getRightBatchEditRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/getRightBatchEdit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", tsType: "FileData" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            file: { type: "string", description: "需要导出的文件，需要判断是否存在" },
            error_count: { type: "number", description: "错误条数，需要判断" },
            succeed_count: { type: "number", description: "成功条数，需要判断" },
        },
    },
    requestFunctionName: "getRightBatchEdit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量恢复正常↗](http://yapi.yishou.com/project/128/interface/api/35608) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/getRightBatchEdit`
 */
export const getRightBatchEdit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRightBatchEditRequestConfig, requestData), ...args);
};
getRightBatchEdit.requestConfig = getRightBatchEditRequestConfig;
/**
 * 接口 [恢复正常↗](http://yapi.yishou.com/project/128/interface/api/35617) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/getRight`
 */
const getRightRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/getRight",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbid[]"],
        properties: { "dbid[]": { type: "string", description: "商品打标ID 数组" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "getRight",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [恢复正常↗](http://yapi.yishou.com/project/128/interface/api/35617) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/getRight`
 */
export const getRight = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getRightRequestConfig, requestData), ...args);
};
getRight.requestConfig = getRightRequestConfig;
/**
 * 接口 [下载批量修改异常原因模板↗](http://yapi.yishou.com/project/128/interface/api/35626) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportCauseBatchDemo`
 */
const exportCauseBatchDemoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/exportCauseBatchDemo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportCauseBatchDemo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [下载批量修改异常原因模板↗](http://yapi.yishou.com/project/128/interface/api/35626) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `GET /erp/StockInRecord/exportCauseBatchDemo`
 */
export const exportCauseBatchDemo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportCauseBatchDemoRequestConfig, requestData), ...args);
};
exportCauseBatchDemo.requestConfig = exportCauseBatchDemoRequestConfig;
/**
 * 接口 [批量修改异常原因↗](http://yapi.yishou.com/project/128/interface/api/35635) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/causeBatchEdit`
 */
const causeBatchEditRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/causeBatchEdit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", tsType: "FileData" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            file: { type: "string", description: "导出文件，需要判断字段存在" },
            error_count: { type: "number", description: "错误条数，需要判断字段存在" },
            succeed_count: { type: "number", description: "成功条数，需要判断字段存在" },
        },
    },
    requestFunctionName: "causeBatchEdit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量修改异常原因↗](http://yapi.yishou.com/project/128/interface/api/35635) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/causeBatchEdit`
 */
export const causeBatchEdit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(causeBatchEditRequestConfig, requestData), ...args);
};
causeBatchEdit.requestConfig = causeBatchEditRequestConfig;
/**
 * 接口 [异常原因编辑↗](http://yapi.yishou.com/project/128/interface/api/35644) 的 **请求配置**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/causeEdit`
 */
const causeEditRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/StockInRecord/causeEdit",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "cause_id", "rd_id", "r_personnel"],
        properties: {
            id: { type: "string", description: "异常商品数据的ID，非打标ID" },
            cause_id: { type: "string", description: "异常原因id" },
            rd_id: { type: "string", description: "责任部门ID" },
            r_personnel: { type: "string", description: "责任人" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "causeEdit",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [异常原因编辑↗](http://yapi.yishou.com/project/128/interface/api/35644) 的 **请求函数**
 *
 * @分类 [商品异常明细↗](http://yapi.yishou.com/project/128/interface/api/cat_3646)
 * @请求头 `POST /erp/StockInRecord/causeEdit`
 */
export const causeEdit = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(causeEditRequestConfig, requestData), ...args);
};
causeEdit.requestConfig = causeEditRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/goodsException3646.js